import React from "react";

const DashPortais = () => {
  return (
    <section>
      <iframe src="https://lookerstudio.google.com/embed/reporting/3a490697-13a3-45d3-996f-1c0d1a06f250/page/o5boD" frameborder="0" allowFullScreen="true"></iframe>
    </section>
  );
};

export default DashPortais;
